<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "AppWrapper",
    mounted() {
        if (this.$route.path === '/') {
            this.$router.push({path: 'movies-list'});
        }
    }
}
</script>

<style scoped>

</style>
